import { useMutation, useQueryClient } from '@tanstack/react-query';
import { AxiosResponse } from 'axios';

import { checklistApi } from '@features/Checklist/api';
import { IChecklistTaskDto, ISwitchChecklistItemResponse } from '@features/Checklist/model/types';
import { keysToCamel } from '@shared/helpers';
import { keysToSnakeObject } from '@shared/helpers/camelToSnake';
import { IDataResponse } from '@shared/model/types/dataResponse.inteface';

export const useSwitchChecklistItem = () => {
    const queryClient = useQueryClient();

    return useMutation({
        mutationFn: checklistApi.switchChecklistDataQuery,
        onSuccess: (response, variables) => {
            const parsedData = keysToCamel<IDataResponse<ISwitchChecklistItemResponse>>(
                response.data
            );
            const switchedChecklistItem = parsedData.data;

            if (!switchedChecklistItem) {
                return;
            }

            queryClient.setQueryData(
                checklistApi.getChecklistDataQuery({ positionGuid: variables.positionGuid })
                    .queryKey,
                (
                    prevResponse: AxiosResponse<IDataResponse<IChecklistTaskDto[]>> | undefined
                ) => {
                    const prevChecklistData = keysToCamel<IDataResponse<IChecklistTaskDto[]>>(
                        prevResponse?.data
                    );

                    if (!prevResponse || !prevChecklistData?.data) {
                        return prevResponse;
                    }

                    const nextChecklistData: IDataResponse<IChecklistTaskDto[]> = {
                        ...prevChecklistData,
                        data: prevChecklistData.data.map((item) =>
                            item.id === switchedChecklistItem.id
                                ? { ...item, isChecked: switchedChecklistItem.isChecked }
                                : item
                        ),
                    };

                    return {
                        ...prevResponse,
                        data: keysToSnakeObject(nextChecklistData),
                    };
                }
            );
        },
    });
};
